module.exports = __webpack_public_path__ + "media/base/builder_tool_small-6d1c20f3.svg";